import { initializeApp } from "@firebase/app";
import { getAuth } from "@firebase/auth";
import { isKnownHostUrl } from "utils/urlUtils";

const firebaseApiKey = window.__APP_CONFIG__?.FIREBASE_API_KEY;

const firebaseConfig = {
  apiKey: firebaseApiKey,
  authDomain: "street-beat-app.firebaseapp.com",
  databaseURL: "https://street-beat-app-default-rtdb.firebaseio.com",
  projectId: "street-beat-app",
  storageBucket: "street-beat-app.appspot.com",
  messagingSenderId: "1017064452947",
  appId: "1:1017064452947:web:cc8f79f612ce6a505d27a6",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export type Environment = "streetbeat-production" | "streetbeat-staging" | "from-host";

export const KNOWN_HOSTS = ["fineco.streetbeatpro.com", "fineco.staging.streetbeatpro.com"];

export const isKnownHost = (): boolean => {
  return isKnownHostUrl(KNOWN_HOSTS);
};

const toApiHost = (): string => {
  const currentHost = window.location.host;
  return `api.${currentHost}`;
};

const environment = async (): Promise<Environment> => {
  if (isKnownHost()) {
    return "from-host";
  }
  await auth.authStateReady();
  if (auth.currentUser && auth.currentUser.email) {
    if (auth.currentUser.email.endsWith("+staging@streetbeat.com"))
      return "streetbeat-staging";
    if (auth.currentUser.email.endsWith("+test@streetbeat.com"))
      return "streetbeat-staging";
  }
  return "streetbeat-production";
};

export { app, auth, environment, toApiHost };
